module.exports = __webpack_public_path__ + "img/ai_hr_writer.15e2dca2.svg";